import './CardEtudiant.css'
import React from 'react'
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import { CiLocationOn } from "react-icons/ci";
import prof from '../../../../Assets/avatar.png';
import { Col } from 'react-bootstrap';
import { MdOutlineWorkOutline } from 'react-icons/md';

export default function CardEtudiant({ nom, adresse, date, prenom,domaine }) {
    return (

        <Col lg={3} md={4} >
            <Card className='p-3 m-2' >
                <div className='position-absolute top-0 end-0'>
                   
                </div>
                <div className="cnt-img d-flex flex-column  justify-content-center py-4 align-items-center">
                    <Card.Img className='imgimg' variant="top" src={prof} />

                    <div className="fw-bold"> {nom} {prenom}</div>
                        <p><MdOutlineWorkOutline /> {domaine}</p>
                        <Form.Text smuted>
                            <CiLocationOn />
                            <span className='px-1'>{adresse}</span>
                        </Form.Text>
                    
                </div>
                <Card.Text className=" ">
                    <div className="d-flex justify-content-between  ">
                        <div>Inscrit le <strong>{date} </strong> </div>
                    </div>
                    <div className='d-flex justify-content-between'>
                       <span>Cours demarrer :</span> 
                       <strong>10</strong>
                    </div>
                </Card.Text>
            </Card >
        </Col>
    )
}
